/** React */
import { HtmlHTMLAttributes } from "react";

/** CSS */
import "./index.css";

import { getThumbBounds } from "./hooks";
import clsx from "clsx";

/** Props */
type Props = HtmlHTMLAttributes<HTMLDivElement> & {
  period?: number;
  values: string[] | number[];
  allPositions?: number[];
  handlePosition: (
    pixelPosition: number,
    thumbPosition: number,
    index: number,
    isHandleSelected?: boolean
  ) => void;
  handleOverContent: (value: string | number | undefined) => void;
  handleOutContent: () => void;
  over: string | number | undefined;
};

export function RangeContent({
  period,
  values,
  allPositions,
  handlePosition,
  handleOverContent,
  handleOutContent,
  over,
}: Props) {
  const handleClickRange = (index: number) => {
    if (allPositions) {
      const newThumbPosition =
        index === 0
          ? allPositions[index] -
            allPositions[0] / 2 -
            getThumbBounds().width / 2
          : allPositions[index - 1] +
            allPositions[0] / 2 -
            getThumbBounds().width / 2;
      handlePosition(allPositions[index], newThumbPosition, index, true);
    }
  };

  return period
    ? values.map((value: string | number | undefined, index: number) => (
        <div
          className="range__content range__content__period"
          onClick={() => handleClickRange(index)}
          onMouseOver={() => handleOverContent(value)}
          onMouseOut={() => handleOutContent()}
        >
          {index % period === 0 ? (
            <>
              <div className="range__tick range__tick__large"></div>
              <div
                className={clsx("range__value", "range__value__period", {
                  "range__value--over": value === over,
                })}
              >
                {value}
              </div>
            </>
          ) : (
            <>
              <div className="range__tick range__tick__small"></div>
              {value === over && (
                <div
                  className={clsx("range__value", "range__value__period", {
                    "range__value--over": value === over,
                  })}
                >
                  {value}
                </div>
              )}
            </>
          )}
        </div>
      ))
    : values.map((value: string | number | undefined, index: number) => (
        <div className="range__content" onClick={() => handleClickRange(index)}>
          <div className="range__tick range__tick__large"></div>
          <div className="range__value">{value}</div>
        </div>
      ));
}
